export default __webpack_public_path__ + "scenes410f4bb.png";